import { type SubPartidasFiltros, cliente } from '@/lib/cliente';
import type { SubPartidaCrear, SubPartidaPatch } from '@adelante/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

export function useSubPartidas(filtros: SubPartidasFiltros = {}) {
  return useQuery({
    queryKey: ['sub-partidas', filtros],
    queryFn: () => cliente.subPartidas.listar(filtros),
  });
}

export function useSubPartida(id: number | undefined) {
  return useQuery({
    queryKey: ['sub-partidas', id],
    queryFn: () => {
      if (!id) throw new Error('id requerido');
      return cliente.subPartidas.obtener(id);
    },
    enabled: !!id,
  });
}

/** Mutación POST /api/sub-partidas (crear). Invalida el listado al éxito. */
export function useCrearSubPartida() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: SubPartidaCrear) => cliente.subPartidas.crear(body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['sub-partidas'] });
    },
  });
}

/** Mutación PATCH /api/sub-partidas/{id}. Invalida cache al éxito. */
export function useActualizarSubPartida() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, parche }: { id: number; parche: SubPartidaPatch }) =>
      cliente.subPartidas.actualizar(id, parche),
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: ['sub-partidas'] });
      qc.invalidateQueries({ queryKey: ['sub-partidas', vars.id] });
    },
  });
}
